import { GETTEXT_ALL_PRIORITY } from '@/shared/lib';
import { create } from 'zustand';
import { SORT_INBOX_KEYS } from './inbox-sort';
import { getListStatusAllReport, getListStatusReport } from '../lib/reportStatus';
import type { InboxState } from './inbox.types';

// Port nguyên văn initialState.goto.inboxes. getListStatusReport() / getListStatusAllReport()
// được gọi ở thời điểm load module, giống initialState cũ (module-level const).
export const defaultInboxState = {
  tab: undefined as any,
  search: {
    searchValue: undefined,
    physicianSearchValue: undefined,
    searchByValue: 'patientName',
    priority: GETTEXT_ALL_PRIORITY,
    sortValue: SORT_INBOX_KEYS.NEW_TO_OLD,
    statusReports: getListStatusReport(),
    statusAllReports: getListStatusAllReport(),
  } as any,
};

/**
 * Zustand store holding the inbox navigation state of the portal. Seeds from defaultInboxState and exposes a single updateInboxGoto action that shallow-merges the given payload into the state root, mirroring the semantics of the former goto reducer.
 *
 * @returns The inbox store hook.
 */
const useInboxStore = create<InboxState>()((set) => ({
  ...defaultInboxState,
  // Ngụ nghĩa của reducer goto cũ: merge SHALLOW một cấp vào nhánh.
  // Chỉ một action duy nhất — mọi consumer đều ghi qua updateGotoData(key: INBOX, value: payload),
  // không có chỗ nào set riêng `tab`, nên không tạo setTab.
  updateInboxGoto: (payload) => set({ ...(payload || {}) }),
}));

export default useInboxStore;
